export default __webpack_public_path__ + "static/media/Text_UnderlineColor.772b91ce.svg";